import { groupBy } from '@fcom/core/utils';

import { FinnairPassengerServiceSelectionItem } from '../api/models';
import { GroupedServices } from '../interfaces';

const getKeyForService = (
  service: FinnairPassengerServiceSelectionItem
): 'confirmed' | 'pendingPayment' =>
  service.includedInTierBenefit || service.ticketed || service.includedInTicketType ? 'confirmed' : 'pendingPayment';

const getIconForService = (
  service: FinnairPassengerServiceSelectionItem
): 'checkmark' | 'shopping-cart' =>
  service.includedInTierBenefit || service.ticketed || service.includedInTicketType ? 'checkmark' : 'shopping-cart';

const isSameServiceItem = (
  servItem1: FinnairPassengerServiceSelectionItem,
  servItem2: FinnairPassengerServiceSelectionItem
): boolean =>
  servItem1.variant === servItem2.variant &&
  servItem1.parameters?.baggageWeight === servItem2.parameters?.baggageWeight &&
  servItem1.totalPrice?.amount === servItem2.totalPrice?.amount &&
  servItem1.ticketed === servItem2.ticketed;

const sortIds = {
  confirmed: 2,
  pendingPayment: 1,
};

export const getGroupedServices = (
  allServices: FinnairPassengerServiceSelectionItem[] = [],
  tierLevel?:string
): GroupedServices[] => {
  const servicesByKey = groupBy(allServices, (service) => getKeyForService(service));
  return Object.entries(servicesByKey)
    .map(([key, services]) => {
      const summaryServices = consolidateServiceAccumulateQuantities(services);
      return {
        key,
        icon: getIconForService(services[0]),
        services: summaryServices,
        tierLevel: tierLevel,
      } as GroupedServices;
    })
    .sort((a, b) => sortIds[b.key] - sortIds[a.key]);
};

const consolidateServiceAccumulateQuantities = (
  services: FinnairPassengerServiceSelectionItem[]
): FinnairPassengerServiceSelectionItem[] => {
  return services.reduce((consolidatedServices, service) => {
    const consolidatedService = consolidatedServices.find((s) => isSameServiceItem(service, s));
    if (consolidatedService) {
      consolidatedService.quantity += service.quantity;
    } else {
      consolidatedServices.push({ ...service });
    }
    return consolidatedServices;
  }, []);
};
